import React from "react";
import Select from "react-select";
import { DROPDOWN_STYLES } from "../../../constants/theme";
import moment from "moment";
import { COMMON } from "../../../constants/localization";
import { DropdownType } from "../../../types/fields";
import { EXPIRATION_DATE_FIELD_TYPES } from "../../../constants/enums";
import { ExpirationDateFieldType } from "../../../types/forms";

const ExpirationDateField = ({input}) => {
  let months: { label: string; value: number }[] = [];
  for (let month = 0; month <= 11; month++) {
    const numericMonth = month + 1 < 10 ? `0${month + 1}` : month + 1;
    months.push({
      label: `${numericMonth} - ${moment().month(month).format("MMMM")}`,
      value: month + 1,
    });
  }

  let years: { label: string; value: number }[] = [];
  const currentYear = moment().year();  
  for (let year = currentYear; year <= currentYear + 10; year++) {
    years.push({
      label: year.toString(),
      value: year,
    });
  }

  const handleChange = (selectedOption: DropdownType, field: ExpirationDateFieldType) => {
    const newValue = {
      month: field === EXPIRATION_DATE_FIELD_TYPES.MONTH ? selectedOption.value : input.value ? input.value.month : null,
      year: field === EXPIRATION_DATE_FIELD_TYPES.YEAR ? selectedOption.value : input.value ? input.value.year : null,
    };
    input.onChange(newValue);
  };

  return(
    <div className="date-field date-field__expiration">
      <div data-cy="expiration-date-selection">
        <label className="date-field__label">{COMMON.MONTH}</label>
        <Select
          styles={DROPDOWN_STYLES}
          menuPlacement="auto"
          id="MonthDateSelection"
          className="data-month-selector"
          onChange={(selectedOption) => handleChange(selectedOption, EXPIRATION_DATE_FIELD_TYPES.MONTH as ExpirationDateFieldType)}
          value={input.value ? months.find(option => option.value === input.value.month) : null}
          options={months}
          onBlur={() => input.onBlur()}
        />
      </div>
      <div>
        <label className="date-field__label">{COMMON.YEAR}</label>
        <Select
          styles={DROPDOWN_STYLES}
          menuPlacement="auto"
          id="YearDateSelection"
          className="data-year-selector"
          onChange={(selectedOption) => handleChange(selectedOption, EXPIRATION_DATE_FIELD_TYPES.YEAR as ExpirationDateFieldType)}
          value={input.value ? years.find(option => option.value === input.value.year) : null}
          options={years}
          onBlur={() => input.onBlur()}
        />
      </div>
    </div>
  )
}

export default ExpirationDateField;
